import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_USERS_PATH_KEY } from '@/swagger/constants/contents-likes-keys';
import {
  API_GET_ADMIN_CONTENTS_LIKES_USERS,
  KEY_GET_ADMIN_CONTENTS_LIKES_USERS,
} from '../constants';
import { MOCK_RESPONSE_GET_ADMIN_CONTENTS_LIKES_USERS } from '../mocks';

type RequestGetAdminContentsLikesUsers = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_USERS_PATH_KEY
>['request']['path'];

/* type ResponseGetAdminContentsLikesUsers = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_CONTENTHASH_USERS_PATH_KEY
>['response']['body']; */

export type CallParamsGetAdminContentsLikesUsers = Omit<
  RequestGetAdminContentsLikesUsers,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetAdminContentsLikesUsers = {
  firstName: string;
  lastName: string;
  role: string;
  email: string;
}[];

type CallErrorGetAdminContentsLikesUsers = {
  message: string;
  code: number;
};

type CallSelectorsGetAdminContentsLikesUsers = {
  data: {
    id: string;
    fullName: string;
    role: string;
    email: string;
  }[];
};

export const getAdminContentsLikesUsersCall = createGeneralCall<
  CallParamsGetAdminContentsLikesUsers,
  CallResponseGetAdminContentsLikesUsers,
  CallErrorGetAdminContentsLikesUsers,
  CallSelectorsGetAdminContentsLikesUsers
>({
  id: KEY_GET_ADMIN_CONTENTS_LIKES_USERS,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_ADMIN_CONTENTS_LIKES_USERS(org as unknown as string, payload.contentHash);
    },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_ADMIN_CONTENTS_LIKES_USERS : undefined,
  selectors: {
    data: ({ selectors }) =>
      createSelector(
        selectors.response,
        res =>
          (res.length > 0 &&
            res.map(user => ({
              id: `${user?.firstName?.toLowerCase()}.${user?.lastName?.toLowerCase()}`,
              fullName: `${user?.firstName} ${user?.lastName}` || '-',
              role: user?.role || '-',
              email: user?.email || '-',
            }))) ||
          [],
      ),
  },
});
